import {
  ALLOTMENT_STATUS,
  ALLOTMENT_THRESHOLD,
  type AllotmentStatusType
} from '../constants';

/**
 * Calculates the allotment status based on availability, allocability, and quantity.
 *
 * @param isAvailable - Whether the item is available
 * @param isAllocable - Whether the item is allocable
 * @param allotmentQuantity - The quantity of available allotments
 * @param isUnlimited - Whether the allotment is unlimited. Unlimited inventory
 *   carries no meaningful quantity (it arrives as 0), so it must never be gated
 *   on `allotmentQuantity` or it would be misreported as sold out.
 * @returns The calculated allotment status (ALLOCABLE, LIMITED, or SOLD_OUT)
 */
export const calculateAllotmentStatus = (
  isAvailable: boolean,
  isAllocable: boolean,
  allotmentQuantity: number,
  isUnlimited = false
): AllotmentStatusType => {
  if (!isAvailable || !isAllocable) {
    return ALLOTMENT_STATUS.SOLD_OUT;
  }
  if (isUnlimited || allotmentQuantity > ALLOTMENT_THRESHOLD) {
    return ALLOTMENT_STATUS.ALLOCABLE;
  }
  if (allotmentQuantity > 0) {
    return ALLOTMENT_STATUS.LIMITED;
  }
  return ALLOTMENT_STATUS.SOLD_OUT;
};
